import '../assets/css/FigmaSection.css'
import Navbar from './NavBar.js'
import FoooterTiles from './FooterSection.js'
import Fade from 'react-reveal/Fade';

function Projects() {
  return (
    <div className="figmaSection">
      <Navbar />
      <h1 className='d-flex justify-content-center'>Figma UI / Animations Prototypes</h1>
      <div className='d-grid justify-content-center'>
        <div className='container'>
          <iframe className='justify-content-center' title="Sun and Moon" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2Fgm7y5H8OEKn95de7B5U4Er%2FUntitled%3Ftype%3Ddesign%26node-id%3D2-183%26t%3DbSNJdxbje5P0ZCBp-1%26scaling%3Dmin-zoom%26page-id%3D0%253A1%26mode%3Ddesign" allowfullscreen></iframe>
        </div>
        <div className='container'>
          <iframe title="Menu bar" width="800" height="450" src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2Fgm7y5H8OEKn95de7B5U4Er%2FUntitled%3Ftype%3Ddesign%26node-id%3D25-264%26t%3D6MEYDkv4pTAb1wxG-1%26scaling%3Dmin-zoom%26page-id%3D0%253A1%26mode%3Ddesign" allowfullscreen></iframe>
        </div>
      </div>
      <Fade left>
        <section>
          <FoooterTiles />
        </section>
      </Fade>
    </div>
  );
}

export default Projects;
